
<template>
	<div :class="columnClass">
        <div v-if="columnLabel=='employee_name'" class="table-td-border-right">
            <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">

                <div class="o-accordion-subtext o-rowtable-text">

                    <div>{{(selectedSortType=='fname_asc')?employee.first_name+" "+employee.last_name : employee.last_name+", "+employee.first_name}}</div>
                </div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.employee_seniority) || 0}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='skill_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.skill_seniority) || 0 }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shifts || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='decline_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipation(employee.participation)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation_july_june_desc'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipationJulyJune(employee.participation_july_june)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_offer'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_offer ? getGloabalDateTimeFormat(employee.last_offer) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_assigned'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_assigned ? getGloabalDateTimeFormat(employee.last_assigned) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_confirmed'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_confirmed ? getGloabalDateTimeFormat(employee.last_confirmed) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='member_since'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.member_since ? getGloabalDateFormat(employee.member_since) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='date_of_hire'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <!-- {{ employee.employee_date_of_hire }} -->
                <div>{{employee.date_of_hire ? getGloabalDateFormat(employee.date_of_hire) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='location'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.address || '- - -'}}</div>
                <!-- <div>Add Location</div> -->
            </div>
        </div>

        <div v-if="columnLabel=='wishlist'" class="table-td-border-right calls-table-cell-inner-table">
            <div class="o-accordion-subtext o-rowtable-text">
                <span>
                    Wishlist:
                    <el-tooltip v-if="employee.wishlist&&employee.wishlist.length&&employee.wishlist[0].employee_message" class="item" effect="light" :content="employee.wishlist[0].employee_message" placement="top-end">
                        <i :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W') ? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                    </el-tooltip>
                    <i v-else-if="employee.wishlist&&employee.wishlist.length" :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W')? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                </span>
                <div>{{(employee && employee.wishlist.length)? getTimeStampValue(employee.wishlist[0].wishlist_timing):''}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field1'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field1)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field2'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field2)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_cell_phone'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>
                    <a :href="'tel:'+getClientContactFormat(employee.phone_number)" class="phone-number-display">
                        {{ employee.phone_number ? getClientContactFormat(employee.phone_number) : '' }}
                    </a>
                </div>
            </div>
        </div>

        <div v-if="columnLabel=='conflicts'">
            <!-- #1661 (job-details render) — the resolver drives ONLY the four COMMITMENT states here;
                 everything else falls through to production's existing paths below, so each state has
                 exactly one render path (collapses the "Vacation" vs "Unavailable due to vacation"
                 double-render MR !426 left behind).
                 ed's complaint was the ABSTRACT WORDS: a bare red "Offered" pill tells the dispatcher
                 nothing — they need WHICH JOB. The detail is already on the row
                 (employee.conflict.primary.detail = {call_id, job_number, job_title, start, end}, built
                 by AvailabilityCheck::computeElsewhereCommitments); this renders it.
                 Mapping (commitmentRender): here=BLUE, elsewhere=RED, [C] prefix on the two CONFIRMED
                 reasons only. Colour is keyed off the REASON per ed's spec, not the resolver's
                 .color — resolveColor currently reds offered_here via RED_PRECEDENCE, but ed's spec is
                 "here=blue"; reconciling the resolver colour is a separate backend concern.
                 Non-commitment states (vacation / recurring / HTS / called-out / passed / timed-out /
                 declined / available) are NOT matched here and render via the production branches that
                 already carry their exact wording + job details. -->
            <div v-if="commitmentRender(employee)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)"
                               :class="'c-tag-btn ' + commitmentRender(employee).colorClass"
                               :style="pillStyle('A', employee.conflict.primary.reason)"
                               :title="conflictHover(employee.conflict)">
                                {{ commitmentRender(employee).text }}
                                <i v-if="employee.conflict.star" class="fa fa-star" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li v-if="allowReassign && employee.conflict.primary.action === 'unassign_reassign_here'" class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red" @click="unassignReassignHere(employee)">Unassign &amp; reassign here</a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- #1661 (resync blocker) — vacation / RU render from the resolver's PER-DAY
                 employee.conflict, NOT the legacy envelope field. checkVacationWithinCall /
                 recurringUnavailability read the whole-run ENVELOPE, so on a month-long job they
                 over-blocked anyone with a vacation anywhere in the month (Abby Hammer: Jul-24–31
                 vacation flagged "vacation" on a Jul-23 call — grid disagreed with the eyeball,
                 which is per-day). conflictHardVacationRU() derives the exact production wording
                 from the resolver's per-day vacation/recurring reasons; if the resolver says green
                 for the day, this returns null and the row falls through to the gap pills. RED,
                 hard block, per the ratified map. The legacy envelope branch is deleted, and its
                 gate is removed from the fall-through branches below. -->
            <!-- #1794 — the key here is a LITERAL, and must stay one. This branch fires
                 on conflictHardVacationRU(), a PER-DAY vacation/recurring derivation.
                 conflict.primary.reason is the WHOLE-ENVELOPE winner, and the two
                 disagree routinely — keying the pill off the envelope rendered a HARD
                 BLOCK as blue or light-orange. The branch has already decided what this
                 pill is; the seam must be told, not asked. -->
            <div v-else-if="conflictHardVacationRU(employee)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" :class="'c-tag-btn ' + pillClass('A', conflictHardVacationRUKey(employee))" :style="pillStyle('A', conflictHardVacationRUKey(employee))">
                                {{ conflictHardVacationRU(employee) }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- #1794 — THE AVAILABLE-ROW BRANCH. It excluded FOUR response statuses by
                 hand and forgot no-show/sent-home, so a no-show with no bookings
                 satisfied every term, matched HERE, and rendered the gap pills
                 plus an assign box instead of reaching its own branch below.
                 Called Out rendered correctly only because its term was present —
                 that asymmetry was the whole defect.
                 One predicate now, so the list cannot drift out of step again. -->
            <div v-else-if="employee.bookings.length == 0 && !hasResponseStatus(employee)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">

                    <!-- #1794 — THIS BRANCH IGNORED client_status_colors ENTIRELY.
                         It rendered a bare blue/green ternary plus a hard-coded orange,
                         with NO pillStyle and NO gapPillClass — so for any worker with
                         no surrounding calls, Vacation Next, Short Turnaround, HTS
                         Elsewhere, On This Job and Available all collapsed into two
                         literal classes. It LOOKED correct for months because
                         u-btn-blue/#37bae8 and u-btn-green/#9edfb6 are the DEFAULTS of
                         gap_tied_to_this_job and gap_fresh; it only diverges once a
                         client customises them, which is exactly what #1794 enables.
                         Now on the same seam as the sibling below, with the predicate
                         expressions copied VERBATIM from it. -->
                    <ul v-if="!employee.previous_calls&&!employee.next_calls" class="o-tag-btn-area o-float-right">
                        <li class="">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" class="o-half-div" :class="'c-tag-btn ' + pillClass('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job)}))" :style="pillStyle('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job)}))">
                                Last call: 24:00+
                            </a>
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" v-if="employee.hts&&employee.hts.length && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job" class="o-half-div" :class="'c-tag-btn ' + pillClass('B', 'gap_hts_elsewhere')" :style="pillStyle('B', 'gap_hts_elsewhere')">
                                {{ getJobTitle(employee.hts) }}
                            </a>
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" class="o-half-div" :class="'c-tag-btn ' + pillClass('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job), vacationNext: (employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}))" :style="pillStyle('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job), vacationNext: (employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}))">
                                <span v-if="employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{ getNextVacationTime(employee.next_vacation) }}
                                </span>
                                <span v-else>Next call: 24:00+</span>
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">

                        <li v-if="Object.keys(employee.previous_calls).length==0" :class="{'o-half-div': true, 'o-half-div-width': htsElsewhere(employee)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="'c-tag-btn ' + pillClass('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job)}))" :style="pillStyle('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job)}))">Last call: 24:00+</a>
                        </li>

                        <li v-if="Object.keys(employee.previous_calls).length!=0" :class="{'o-half-div': true, 'o-half-div-width': htsElsewhere(employee)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="['c-tag-btn ' + pillClass('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !checkTurnOver(employee.previous_calls) && !employee.confirmed_on_this_job), shortTurn: (Object.keys(employee.hts).length==0 && checkTurnOver(employee.previous_calls))})), {'u-btn-border-red': checkPrevNextCallSameDay(employee.prev_Call, employee.prev_Call_job_id) && borderEnabled()}]" :style="pillStyle('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !checkTurnOver(employee.previous_calls) && !employee.confirmed_on_this_job), shortTurn: (Object.keys(employee.hts).length==0 && checkTurnOver(employee.previous_calls))}))">
                                {{ getPrevCallTime(employee.previous_calls) }}
                            </a>
                        </li>

                        <li v-if="htsElsewhere(employee)" class="o-half-div o-half-div-width">   
                            <!-- #1794 — was a literal u-btn-light-orange with no pillStyle,
                                 so this pill ignored the chart. Unnoticed because #fb8b03
                                 IS gap_hts_elsewhere's default: change that row's colour
                                 and the configured HTS pill beside it moved while this one
                                 stayed put.
                                 THE KEY IS A LITERAL, deliberately. The v-if above has
                                 already decided what this pill is, so the seam is TOLD, not
                                 asked — same as the System A branches. Calling gapPillClass()
                                 here would make the seam derive a key, which is a new
                                 predicate and is what regressed step 1. -->
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="'c-tag-btn ' + pillClass('B', 'gap_hts_elsewhere')" :style="pillStyle('B', 'gap_hts_elsewhere')">
                                {{getJobTitle(employee.hts)}}
                            </a>
                        </li>

                        <li v-if="employee.next_calls&&Object.keys(employee.next_calls).length==0" :class="{'o-half-div':  true, 'o-half-div-width': htsElsewhere(employee)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="'c-tag-btn ' + pillClass('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job), vacationNext: (employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}))" :style="pillStyle('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job), vacationNext: (employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}))">
                                <span v-if="employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{getNextVacationTime(employee.next_vacation)}}
                                </span>
                                <span v-else>Next call: 24:00+</span>
                            </a>
                        </li>

                        <li v-if="Object.keys(employee.next_calls).length!=0" :class="{'o-half-div':  true, 'o-half-div-width': htsElsewhere(employee)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="['c-tag-btn ' + pillClass('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !checkTurnOver(employee.next_calls) && !employee.confirmed_on_this_job), shortTurn: (Object.keys(employee.hts).length==0 && checkTurnOver(employee.next_calls)), vacationNext: (employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)})), {'u-btn-border-red': checkPrevNextCallSameDay(employee.next_Call, employee.next_Call_job_id) && borderEnabled()}]" :style="pillStyle('B', gapPillClass({blue: gapPillBlue(employee), tiedByHts: tiedByHtsOnThisJob(employee), htsElsewhere: (Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), fresh: (Object.keys(employee.hts).length==0 && !checkTurnOver(employee.next_calls) && !employee.confirmed_on_this_job), shortTurn: (Object.keys(employee.hts).length==0 && checkTurnOver(employee.next_calls)), vacationNext: (employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}))">
                                <span v-if="employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{ getNextCallTime(employee.next_calls) }} <br />
                                    {{ getNextVacationTime(employee.next_vacation) }}
                                </span>
                                <span v-else>{{ getNextCallTime(employee.next_calls) }} </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else-if="employee.bookings.length>0" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" v-if="!checkAssignedJob(employee)">
                            <a href="javascript: void(0)" :class="checkThisClickCooking(employee.bookings)?'c-tag-btn u-btn-orange':'c-tag-btn u-btn-red'">
                            {{checkThisClickCooking(employee.bookings)?employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')':'OTHER BOOKING'}}
                            </a>
                        </li>

                        <li class="o-half-div" v-else>
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-blue">
                            {{employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')'}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul v-if="getDeclineStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" @click="openDeclinedModal(employee)">
                            <a href="javascript: void(0)" :class="'c-tag-btn ' + pillClass('A', 'declined')" :style="pillStyle('A', 'declined')">
                                Declined : {{getCallActionByType(employee.call_actions, "Declined")[0].job_name}}
                            </a>
                        </li>
                    </ul>

                    <!-- #1690 T5b — no-show / sent-home: YELLOW, re-offerable "no" family, no assign
                         tool. The slot was cleared and this is the logged record (also on the decline tab). -->
                    <ul v-else-if="getNoShowSentHomeStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" :class="'c-tag-btn ' + pillClass('A', getNoShowSentHomeKey(employee.call_actions))" :style="pillStyle('A', getNoShowSentHomeKey(employee.call_actions))">
                                {{ getNoShowSentHomeLabel(employee.call_actions) }}
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getCallOutStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" :class="'c-tag-btn ' + pillClass('A', 'called_out')" :style="pillStyle('A', 'called_out')">
                                Called Out : {{getCallActionByType(employee.call_actions, "Call Out")[0].job_name}}
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getTimeOutStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <el-tooltip content="Declined Schedule" placement="top" effect="dark">
                                <a href="javascript: void(0)" :class="'c-tag-btn ' + pillClass('A', 'timed_out')" :style="pillStyle('A', 'timed_out')" @click="openTimedOutModal(employee)">
                                    Timed Out : {{getCallActionByType(employee.call_actions, "Timed Out")[0].job_name}}
                                </a>
                            </el-tooltip>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <el-tooltip content="Declined Schedule" placement="top" effect="dark">
                                <a href="javascript: void(0)" :class="'c-tag-btn ' + pillClass('A', 'passed')" :style="pillStyle('A', 'passed')" @click="openPassedModal(employee)">
                                    Passed : {{getCallActionByType(employee.call_actions, "Passed")[0].job_name}}
                                </a>
                            </el-tooltip>
                        </li>
                    </ul>

                </div>
            </div>
        </div>

        <el-dialog title="Schedule" width="85%" :close-on-click-modal="false" custom-class="pass-time-out-modal" :visible.sync="dialogPassedVisible">
            <ScheduleModal :routeEmployeeId="routeEmployeeId" v-if="routeEmployeeId==employee.id" />
        </el-dialog>

        <el-dialog title="Schedule" width="85%" :close-on-click-modal="false" custom-class="pass-time-out-modal" :visible.sync="dialogTimeOutVisible">
            <ScheduleModal :routeEmployeeId="routeEmployeeId" v-if="routeEmployeeId==employee.id" />
        </el-dialog>
	</div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import ScheduleModal from '@/components/scheduleModal.vue';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../../global.js';
    import { bus } from '../../../main';
    import service from '../../../services.js';
    import { loadStatusColors } from "../../../statusColors.js"; // #1794 step 3

    export default {
        props: {
            // #1661 — only the single-call assign grid has a single "here" call to
            // reassign onto, so only it opts into the recoverable-red reassign control.
            // Bulk (multi-call) shows the color badge without the action.
            allowReassign: {
                type: Boolean,
                required: false,
                default: false
            },
            isSteward: {
                type: Number,
                required: true
            },
            isDispatcher: {
                type: Number,
                required: true
            },
            employee: {
                type: Object,
                required: true
            },
            columnLabel: {
                type: String,
                required: true
            },
            client:{
                type: Object,
                required: true
            },
            selectedSortType:{
                type: String,
                required: true
            },
            callStartTime:{
                type:String,
                required: true
            },
            callEndTime:{
                type:String,
                required: true
            },
            userDateFormat: {
                type:String,
                required: false
            },
            userTimeFormat: {
                type:String,
                required: false
            }
        },
        data() {
            return {
                // #1794 step 3 — resolved once per page via the module-level cache.
                // Null until it lands, and null forever if the fetch fails; every
                // consumer falls back to the built-in palette.
                statusColors: null,
               columnClass:'',
               turnoverTime: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                address:'',
                routeEmployeeId: '',
                modalActionName: '',
                dialogTimeOutVisible: false,
                dialogPassedVisible: false
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                employeeId: "employeeId",
                bulkCallStartTime: 'bulkCallStartTime',
                bulkCallEndTime: 'bulkCallEndTime'
            })
        },
        components: {
            ScheduleModal
        },
        methods: {
            fetchStatusColors() {
                const clientId = this.userClientID || (this.client && this.client.id);
                if (!clientId) return;
                loadStatusColors(clientId, {
                    Authorization: this.userToken,
                    "cs3-context-role": this.userRole,
                    "cs3-context-clientId": clientId,
                }).then((map) => { this.statusColors = map; });
            },
            // #1794 step 3 — the configured row for a key, or null.
            // TOLD the key, never deriving one. A seam that derives a key is a new
            // predicate, and that is what broke step 1.
            // #1867 — the internal booking-elsewhere reasons BORROW the Confirmed /
            // Offered rows. ed: "same color, marker tells them apart", and the ruling
            // adds no row to the ratified fourteen (#1781) — so there is nothing to
            // look up under their own names and a client's customised Confirmed
            // colour must follow them.
            //
            // Same technique the `confirmed_here_hts_hold` COMBINATION row already
            // uses: a config row chosen by rendering logic rather than by a resolver
            // primary of the same name. TOLD the alias, still never deriving a key.
            // #1868 — the alias comes from the API (`ClientStatusColor::COLOUR_ALIAS`),
            // not from a copy here. #1867 hardcoded it in this file; a contract with
            // two hand-maintained copies drifts, and this one already had a second
            // consumer (the config endpoint's fallback path) that did not agree.
            aliasFor(key) {
                const a = this.statusColors && this.statusColors.aliases;
                return (a && a[key]) || key;
            },
            pillConfig(key) {
                if (!this.statusColors || !key) return null;
                key = this.aliasFor(key);
                return this.statusColors.byStatus[key]
                    // A signal the resolver emits with no configured row. The API
                    // returns a defined fallback so nothing is invented here.
                    || this.statusColors.fallbacks[key]
                    || null;
            },
            // hex AND font_hex, inline. They are arbitrary per client so a class
            // cannot carry them. font_hex is not cosmetic: a rep can choose a dark
            // background, and without the font colour that renders dark-on-dark.
            //
            // Returns {} when there is no config — the built-in class then supplies
            // the colour, which is what makes an uncustomised client byte-identical.
            pillStyle(system, key) {
                const c = this.pillConfig(key);
                if (!c || !c.hex) return {};
                // `!important` IS REQUIRED, and this is the subtle part.
                //
                // `.u-btn-blue` is `#37bae8!important` and `.u-btn-yellow1` is
                // `#e8e000bf!important` in this component. A stylesheet `!important`
                // BEATS a normal inline style, so without the suffix a configured
                // colour would silently fail to apply to exactly those two pills —
                // "configurable and ignored", the failure this step exists to remove.
                // The rest would work, which is worse: it would look like it worked.
                //
                // Vue 2 supports this: its style module matches /\s*!important$/ and
                // routes the value through setProperty(..., 'important').
                //
                // For an UNCUSTOMISED client the value equals the class's own colour,
                // so the rendered pixel is unchanged — the gate still holds.
                const style = { background: c.hex + ' !important' };
                if (c.font_hex) style.color = c.font_hex + ' !important';
                return style;
            },
            // The same-day-adjacency BORDER. The predicate stays
            // checkPrevNextCallSameDay() in the template — untouched. This only
            // answers whether the client has that overlay switched on, defaulting
            // to ON so an uncustomised client is unchanged.
            borderEnabled() {
                const c = this.pillConfig('gap_same_day');
                return c ? !!c.has_border : true;
            },
            // ── THE PRESENTATION SEAM (#1794 step 1) ────────────────────────────
            //
            // ONE function: (system, key) -> the class a true predicate emits.
            //
            // GOVERNING CONSTRAINT (ed, 2026-08-27): "the current assign page is
            // working well as functions go. in particular HTS is working the best it
            // has in over a year." The safety argument here is therefore structural,
            // not visual: on this page every PREDICATE is function and every CLASS
            // NAME is presentation, and they separate cleanly.
            // NO PREDICATE CHANGES -> NO BEHAVIOUR CHANGES.
            //
            // Untouched, deliberately: gapPillBlue, isCurrentJobHTS, checkTurnOver,
            // checkPrevNextCallSameDay, htsHoverTitle, commitmentRender's COMMITMENT
            // test, resolveColor's precedence, and every v-if.
            //
            // A NO-OP BY CONSTRUCTION. Every value is the class that state already
            // renders at master@1c5a9253 — this branch IS that baseline, so the diff
            // is the proof. Cross-checked against
            // knowledge/assign-grid-css-alias-reference.md.
            //
            //   u-btn-green #9edfb6 · u-btn-yellow #ffea9e · u-btn-red #f8bfbf
            //   u-btn-blue  #37bae8 (COMPONENT !important override, NOT #8dcce2)
            //   u-btn-light-orange #fb8b03
            //
            // NO CONFIG READS. Those arrive at step 3, through this same function, so
            // the seam is the only thing that changes then.
            //
            // SYSTEM A ONLY. System B (the Last/Next-call gap pills) is not routed
            // here yet, on purpose: several of its classes can be truthy at once and
            // today stylesheet order decides. Encoding that precedence is step 2;
            // doing it here would force the decision inside a step required to change
            // nothing.
            pillClass(system, key) {
                // #1868 — an aliased status wears its target's class too, so the
                // built-in colour and the configured colour can never disagree.
                key = this.aliasFor(key);
                const A = {
                    available:                  'u-btn-green',
                    confirmed_here:             'u-btn-blue',
                    confirmed_here_hts_hold:    'u-btn-blue',
                    booked_confirmed_elsewhere: 'u-btn-red',
                    booked_offered_elsewhere:   'u-btn-red',
                    offered_here:               'u-btn-red',
                    // #1867/#1868 — kept as the floor for the case where the config
                    // has not loaded at all (`statusColors` null), so `aliasFor`
                    // cannot resolve. With config present the alias sends these to
                    // confirmed_here / offered_here above and these are unreachable.
                    // They must keep matching those two, and the unit test asserts it.
                    booked_confirmed_local:     'u-btn-blue',
                    booked_offered_local:       'u-btn-red',
                    vacation:                   'u-btn-red',
                    recurring:                  'u-btn-red',
                    declined:                   'u-btn-red',
                    called_out:                 'u-btn-yellow',
                    passed:                     'u-btn-yellow',
                    timed_out:                  'u-btn-yellow',
                    no_show:                    'u-btn-yellow',
                    sent_home:                  'u-btn-yellow',
                    hts_hold:                   'u-btn-light-orange',
                };
                // SYSTEM B — the gap pills. Populated so a 'B' lookup resolves to the
                // class that condition already renders, instead of falling through to
                // the blocked-red fallback. Nothing calls this yet; step 3 wires it.
                const B = {
                    gap_tied_to_this_job: 'u-btn-blue',
                    gap_hts_elsewhere:    'u-btn-light-orange',
                    gap_fresh:            'u-btn-green',
                    gap_short_turnaround: 'u-btn-yellow',
                    gap_vacation_next:    'u-btn-yellow1',
                    // OVERLAY, not a fill — composes with whichever fill won.
                    gap_same_day:         'u-btn-border-red',
                };
                const table = (system === 'A') ? A : (system === 'B' ? B : {});

                // #1794 step 3 — a configured row supplies the colour via
                // pillStyle(); the class then only needs to be a harmless base. The
                // built-in table is the DEFAULT, never deleted: it is what draws
                // before the config lands, when a client has no row, and when the
                // fetch fails.
                if (Object.prototype.hasOwnProperty.call(table, key)) return table[key];

                // ONE fallback, SAFE direction: an unrecognised key renders BLOCKED,
                // never free. The deleted five-colour map defaulted to GREEN — the
                // same failure class as #1790's `declined` falling through to green.
                // Logged once per key: a silent fallback is how that one survived
                // since #1661.
                if (!this.$_seamUnknown) this.$_seamUnknown = {};
                const tag = system + ':' + key;
                if (key && !this.$_seamUnknown[tag]) {
                    this.$_seamUnknown[tag] = true;
                    console.warn('[#1794] presentation seam has no class for ' + tag + ' — rendering blocked (red)');
                }
                return 'u-btn-red';
            },
            // ── SYSTEM B PRECEDENCE (#1794 step 2) ──────────────────────────────
            //
            // Several gap-pill classes can be true AT ONCE and nothing in the code
            // decides between them — the CSS does, by specificity and source order.
            // This makes that decision explicit, in one place.
            //
            // PREDICATES ARE NOT RE-EVALUATED HERE. The template evaluates exactly the
            // expressions it evaluated before and passes the RESULTS in. This function
            // cannot change what is true, only which true thing wins. That distinction
            // is the one #1794's L209 regression turned on: a seam that DERIVES a key
            // is a new predicate; a seam that is TOLD one is not.
            //
            // THE ORDER IS MEASURED, NOT THE ONE THE OLD COMMENT CLAIMED. The claim was
            // blue > light-orange > yellow > green — right as far as it goes, since
            // .u-btn-blue carries !important and those three do not — but it OMITS
            // u-btn-yellow1:
            //
            //   .u-btn-blue     #37bae8   !important   declared first
            //   .u-btn-yellow1  #e8e000bf !important   declared LATER
            //
            // Both !important, both single-class, so specificity ties and the later
            // declaration wins: yellow1 beats blue today. Its predicate
            // (next_vacation) is independent of gapPillBlue(), so on the Next-call
            // pills both genuinely apply. Encoding the claim literally would put blue
            // above yellow1 and visibly change any employee tied to this job WITH a
            // vacation next.
            //
            //   vacation_next > tied_to_this_job > hts_elsewhere > short_turnaround > fresh
            //
            // The same-day-adjacency BORDER is not in this list: it is an overlay, not
            // a fill, so it composes rather than competes.
            // Returns the CONFIG KEY, not a class (#1794 step 3). The class then
            // comes from pillClass('B', key) and the colour from pillStyle('B', key),
            // so one decision drives both and they cannot drift. The precedence and
            // the predicates behind it are unchanged from step 2.
            gapPillClass(p) {
                // #1794 (ed, 2026-08-28, testing on resync): "short turnaround should win".
                //
                // A DELIBERATE PRECEDENCE CHANGE, not a no-op. Short Turnaround used
                // to sit BELOW blue, and gapPillBlue() is true whenever the worker is
                // confirmed on this job or holds HTS on it — so anyone already tied to
                // the job never showed their short-turnaround state, which is the
                // warning that actually costs money. It rendered blue instead.
                //
                // STATED CONSEQUENCE: this also puts shortTurn above htsElsewhere.
                // That was already true of blue, so the relative order of blue and
                // htsElsewhere is unchanged — but a short turnaround now outranks an
                // HTS-elsewhere pill where it previously did not.
                //
                // vacationNext STAYS on top: ed has not said otherwise.
                if (p.vacationNext)  return 'gap_vacation_next';
                if (p.shortTurn)     return 'gap_short_turnaround';
                // #1794 (ed, 2026-08-28): "same pattern would apply to a non hts
                // job except it would be the assigned red color" / "reuse them".
                //
                // The tied pill now says HOW the worker is tied, reusing the System A
                // rows rather than adding new ones — same state, same meaning, one
                // place to set it, and it cannot drift from the commitment pill
                // beside it:
                //
                //     tied by an HTS hold on THIS job -> confirmed_here_hts_hold (blue)
                //     tied by being confirmed here    -> confirmed_here          (red)
                //
                // HTS WINS when both are true, matching System A, where a
                // confirmation on an HTS job resolves to confirmed_here_hts_hold
                // rather than to confirmed_here.
                //
                // ⚠️ THE TWO SYSTEMS ASK DIFFERENT QUESTIONS AND THIS DOES NOT FULLY
                // RECONCILE THEM — see the MR. System A keys off the VIEWED JOB's
                // `jobs.hts_flag`; this keys off whether the EMPLOYEE's HTS list
                // contains this job, because that is the only HTS fact this component
                // is given (there is no `job` prop, on any of its five parents).
                // They agree wherever an HTS hold exists for the worker on this job,
                // and diverge for a worker confirmed on an HTS job who holds no HTS
                // on it. Closing that needs the job's flag passed in — a data change,
                // not a colour one.
                if (p.blue)          return p.tiedByHts ? 'confirmed_here_hts_hold' : 'confirmed_here';
                if (p.htsElsewhere)  return 'gap_hts_elsewhere';
                if (p.fresh)         return 'gap_fresh';
                // Nothing true — the element carries no colour class today and still
                // does not. Inventing one here would be a visible change, not a no-op.
                return '';
            },
            /**
             * #1794 — is this worker tied to THIS job by an HTS hold?
             *
             * The HTS half of gapPillBlue, named so the tied pill can say WHICH tie
             * it is. Reuses isCurrentJobHTS — the existing predicate for "HTS hold
             * on this job" — rather than re-deriving it, because a second copy of a
             * predicate drifting from the first is the defect this whole issue
             * began with.
             *
             * Deliberately NOT the same question System A asks. System A keys off
             * the VIEWED JOB's `jobs.hts_flag`; this component is never given the
             * job, so it can only ask about the employee's HTS list. See the MR.
             */
            tiedByHtsOnThisJob(employee) {
                return !!(employee && employee.hts
                    && Object.keys(employee.hts).length > 0
                    && this.isCurrentJobHTS(employee.hts));
            },
            gapPillBlue(employee) {
                // #1661 — a "Last/Next call" gap pill is BLUE when the candidate is tied to THIS
                // job: an HTS hold on this job (production's existing signal) OR already CONFIRMED
                // on this job on another call/day (employee.confirmed_on_this_job, backend). Blue =
                // "already on the job, re-assignable"; green = a fresh candidate. Blue wins over
                // green / yellow / light-orange, mirroring how isCurrentJobHTS already behaves.
                var htsOnThisJob = employee.hts && Object.keys(employee.hts).length > 0 && this.isCurrentJobHTS(employee.hts);
                return !!(htsOnThisJob || employee.confirmed_on_this_job);
            },
            /**
             * #1794 — the shared vacation/RU computation, extracted so the WORDING
             * and the pill COLOUR read the same flags. A PURE MOVE: the body below
             * is unchanged, it now returns the flags instead of the wording.
             */
            vacationRUFlags(employee) {
                // #1661 (resync blocker) — the cell's vacation/RU state, sourced from the
                // resolver's PER-DAY employee.conflict, NOT the legacy envelope field. Returns the
                // exact production wording when the resolver's primary (per-day) is a hard
                // vacation/recurring block, else null (→ the row falls through to the gap pills).
                // Vacation always outranks yellow/orange in the resolver, and a red booking that
                // outranks vacation is already rendered by commitmentRender (branch 1) — so this is
                // reached only when vacation/recurring IS the displayed per-day state. `others`
                // carries the second reason for the combined phrase.
                const c = employee && employee.conflict;
                const p = c && c.primary;
                const others = c && c.others ? c.others.map((o) => o && o.reason) : [];
                const reasonVac = !!(p && p.reason === 'vacation') || others.indexOf('vacation') !== -1;
                const reasonRU  = !!(p && p.reason === 'recurring') || others.indexOf('recurring') !== -1;
                // #1690 T4 — the pill must be RED wherever the assign tool is hard-blocked,
                // never green-with-no-tool (Ed q2). The tool (single/bulk assignHardBlocked)
                // disables on the FRONTEND per-day recurring-unavailability check
                // recurringUnavailability(available_times) — the resolver's per-day 'recurring'
                // reason does not always cover the #1680 overnight-window nuance, so a worker
                // could show green here yet have no assign tool. Mirror the SAME check so the
                // two agree: red pill ⇔ blocked tool.
                const hasVac = reasonVac;
                const hasRU  = reasonRU || this.recurringUnavailability(employee.available_times);
                return { hasVac, hasRU };
            },
            /**
             * #1661 / #1690 — the wording, from the flags above.
             *
             * Unchanged behaviour: the same three strings for the same three
             * states, and null when neither holds so the row falls through to the
             * gap pills.
             */
            conflictHardVacationRU(employee) {
                const { hasVac, hasRU } = this.vacationRUFlags(employee);
                if (!hasVac && !hasRU) {
                    return null;
                }
                if (hasVac && hasRU) {
                    return 'Unavailable due to vacation and recurring unavailability';
                }
                return hasVac
                    ? 'Unavailable due to vacation'
                    : 'Unavailable due to recurring unavailability';
            },
            /**
             * #1794 — WHICH of the two this row is, for the pill colour.
             *
             * The branch fires for vacation OR recurring but the pill key was the
             * literal 'vacation', so a recurring-unavailable employee rendered in
             * VACATION's colour — cs3demo #00fae9 cyan instead of #f8bfbf pink,
             * which is what ed is looking at.
             *
             * READS THE SAME FLAGS AS THE WORDING, deliberately. The #1690 T4
             * mirror (`recurringUnavailability(available_times)`) lives in
             * vacationRUFlags and is computed ONCE; re-deriving it here would be a
             * second hand-maintained copy of the very test whose drift caused this
             * MR's first defect.
             *
             * BOTH -> 'vacation', which is not a new decision: the combined wording
             * puts vacation first and AvailabilityCheck::RED_PRECEDENCE orders
             * vacation ahead of recurring.
             */
            conflictHardVacationRUKey(employee) {
                const { hasVac } = this.vacationRUFlags(employee);
                return hasVac ? 'vacation' : 'recurring';
            },
            commitmentRender(employee) {
                // #1690 (ratified 2026-08-11) — for the four COMMITMENT reasons, return the
                // pill to render: { colorClass, text }. Returns null for every other state so
                // the template falls through to the existing branches (vacation/RU/HTS/called-
                // out/passed/timed-out/declined/available) — one render path per state.
                //
                // Pill COLOUR is taken from the resolver's .color — the SINGLE SOURCE OF TRUTH
                // (Ed's ruling: booked-elsewhere is RED, not orange; only the resolver decides
                // colour). Markers are SEMANTIC, keyed off the reason, and ride on top of colour:
                //   [C] = confirmed  → confirmed_here (blue) + booked_confirmed_elsewhere (red)
                //   [U] = unconfirmed here → offered_here (red)
                // #1794 — BOTH signals belong in this list, for opposite reasons.
                //
                // `confirmed_here_hts_hold` (!704) is EMITTED by the resolver, so
                // omitting it would send the row to the GAP PILLS rather than a
                // commitment pill — the no-show failure mode, on a live signal.
                //
                // `booked_offered_elsewhere` can no longer be a primary reason (this
                // MR removes it from RED_PRECEDENCE: an offer elsewhere must not block
                // an offer here), so its entry is UNREACHABLE — and kept deliberately.
                // If the signal is ever restored to RED_PRECEDENCE, a missing entry
                // here would produce that same gap-pill fall-through. Unreachable is
                // harmless; absent is a trap for the next person.
                // #1867 — the two `_local` reasons are commitment pills too. Omitting
                // one sends the row to the GAP PILLS instead of a commitment pill —
                // the no-show failure mode this list already warns about, and now on
                // two live signals.
                const COMMITMENT = ['confirmed_here', 'confirmed_here_hts_hold', 'booked_confirmed_elsewhere', 'booked_offered_elsewhere', 'offered_here', 'booked_confirmed_local', 'booked_offered_local'];
                // #1794 step 1 — was a second colour->class map. Routes through the
                // seam now. The COMMITMENT test above is untouched: it is function.
                // #1794 — same [C] marker: it is the same confirmation, on the same
                // job. Only the colour differs.
                // #1867 — ed: "The internal is `[C] JobName #` or `[U] JobName #`".
                // `booked_confirmed_elsewhere` keeps its entry but can no longer reach
                // it: external takes the ELSEWHERE branch below, which prefixes nothing.
                const markerByReason = { confirmed_here: '[C] ', confirmed_here_hts_hold: '[C] ', booked_confirmed_elsewhere: '[C] ', offered_here: '[U] ', booked_confirmed_local: '[C] ', booked_offered_local: '[U] ' };

                const primary = employee && employee.conflict && employee.conflict.primary;
                if (!primary || COMMITMENT.indexOf(primary.reason) === -1) return null;

                const d = primary.detail || {};
                const title = d.job_title ? String(d.job_title).trim() : '';
                const number = (d.job_number !== undefined && d.job_number !== null && d.job_number !== '')
                    ? '#' + d.job_number
                    : '';
                // Job name + number. Fall back to the resolver label only if the detail is missing
                // entirely, so the pill is never blank (should not happen — detail is always built
                // for these reasons — but a missing detail must not render an empty pill).
                let job = [title, number].filter(Boolean).join(' ').trim();
                if (!job) job = primary.label || '';

                // #1794 SOC2 (ed, 2026-08-28): "Other Booking should show OTHER
                // BOOKING — revealing the details breaks the soc2 privacy wall."
                //
                // The REAL fix is server-side: AvailabilityCheck no longer ships
                // job_number / job_title / call_id / start / end for these two
                // reasons, so `primary.detail` is now { group, blocking } and there
                // is nothing here to reveal. This line is the display half of that
                // — on its own it would have been theatre, because the identifiers
                // were already in the API response.
                //
                // `OTHER BOOKING` is the string the legacy bookings branch already
                // uses for the same concept, reused rather than re-invented, with
                // no marker prefix.
                //
                // confirmed_here / offered_here keep marker + job: those are THIS
                // job, there is no wall, and the detail is the point of the pill.
                //
                // #1821 (ed, 2026-09-03) — ONE field is now revealed: WHICH client the
                // worker is booked with, appended as `OTHER BOOKING - <client>`.
                //
                //   "this is the middle ground. Local 2 wants to know all the details
                //    but they can't, because they might hold that against an employee."
                //
                // The requesting local gets enough to plan around the conflict and
                // nothing that could be used against the worker. THE CLIENT NAME IS THE
                // CEILING — this reads `conflict_client` and must never start reading
                // `detail` for these two reasons, which is precisely the wall #1794
                // built. `conflict_client` is null on a same-tenant booking elsewhere
                // and on any client row with no name, and the pill then reads exactly
                // what it read before.
                //
                // #1822 (ed, 2026-09-03) — when the conflicting booking is on another job
                // of the SAME LOCAL, the pill NAMES that job instead of saying nothing:
                //
                //   "joe is booked on the 4th, still other booking should be replaced
                //    with the local job."
                //
                // `conflict_job` is populated ONLY on the same-tenant path (the resolver
                // builds it from a single-tenant query), and `conflict_client` ONLY on the
                // cross-tenant one. They are mutually exclusive, so this reads as a
                // three-way and never has to choose between them:
                //
                //   same local     `333697 - Mainstage - Legacy Prep Rigging 8/26`
                //   another local  `OTHER BOOKING - Local 51`      <- #1821's ceiling
                //   neither known  `OTHER BOOKING`                 <- unchanged
                //
                // Still reads NAMED FIELDS, never `detail`, for these two reasons — that
                // is the #1794 wall and it stays exactly where it was.
                // #1867 — ELSEWHERE is now EXTERNAL ONLY. It used to hold both paths
                // because they shared one key, which is why the same-local case had to
                // be teased back out of it by testing `conflict_job`. The resolver
                // makes that distinction now, so this reads the reason directly.
                const ELSEWHERE = ['booked_confirmed_elsewhere', 'booked_offered_elsewhere'];
                const LOCAL_ELSEWHERE = ['booked_confirmed_local', 'booked_offered_local'];
                const client = primary.conflict_client ? String(primary.conflict_client).trim() : '';
                const localJob = this.conflictJobLabel(primary.conflict_job);
                let text;
                if (ELSEWHERE.indexOf(primary.reason) !== -1) {
                    // External: anonymous. Client name is #1821's ceiling, nothing more.
                    text = 'OTHER BOOKING' + (client ? ' - ' + client : '');
                } else if (LOCAL_ELSEWHERE.indexOf(primary.reason) !== -1) {
                    // Internal: `[C] 333879 - Mainstage`. The job identity rides in
                    // `conflict_job`, never in `detail` — #1794's wall is untouched, and
                    // `job` above is deliberately not consulted here for that reason.
                    // Falls back to the label so the pill is never blank.
                    text = (markerByReason[primary.reason] || '') + (localJob || primary.label || '');
                } else {
                    text = (markerByReason[primary.reason] || '') + job;
                }

                return {
                    // Keyed off `primary.reason` — the value the COMMITMENT test on the
                    // line above already gated on. NOT a re-derivation: reading anything
                    // else here (others[], a per-day source) would be a NEW PREDICATE,
                    // which is exactly what regressed the vacation branch.
                    colorClass: this.pillClass('A', primary.reason),
                    text: text,
                };
            },
            // #1822 — `<job_number> - <title>`, or '' when the resolver shipped no
            // same-local job. ONE builder so the pill and the star-hover can never
            // drift into naming the job two different ways.
            conflictJobLabel(cj) {
                if (!cj || !cj.job_number) return '';
                const title = cj.job_title ? String(cj.job_title).trim() : '';
                return String(cj.job_number) + (title ? ' - ' + title : '');
            },
            conflictSignalLine(sig) {
                if (!sig) return '';
                let line = sig.label || sig.reason || '';
                const d = sig.detail;
                if (d && d.job_number) {
                    line += ': #' + d.job_number + (d.job_title ? ' ' + d.job_title : '');
                } else {
                    // #1822 gate (c) — a same-local booking elsewhere carries its job in
                    // `conflict_job`, not `detail` (detail is {group, blocking} since
                    // #1794), so the hover line has to read it from there to name the
                    // same job the pill names.
                    const cj = this.conflictJobLabel(sig.conflict_job);
                    if (cj) line += ': #' + cj;
                }
                return line;
            },
            conflictHover(conflict) {
                if (!conflict) return '';
                const lines = [];
                if (conflict.primary) lines.push(this.conflictSignalLine(conflict.primary));
                (conflict.others || []).forEach((o) => lines.push(this.conflictSignalLine(o)));
                return lines.join('\n');
            },
            unassignReassignHere(employee) {
                // Recoverable red (booked elsewhere): unassign the elsewhere call and
                // reassign to this call. Emitted for the parent grid to run the
                // existing assign flow against the conflict detail.
                this.$emit('unassign-reassign-here', {
                    employee: employee,
                    conflict: employee.conflict,
                });
            },
            openPassedModal(employee) {
                this.routeEmployeeId = employee.id;
                this.modalActionName = 'passed';
                this.$forceUpdate();
                this.dialogPassedVisible = true;
            },
            closeModal(name) {
                this.modalActionName='';
                this.dialogPassedVisible = false;
                this.dialogTimeOutVisible = false;
                this.routeEmployeeId = '';
            },
            openTimedOutModal(employee) {
                this.routeEmployeeId=employee.id;
                this.modalActionName='timed-out';
                this.$forceUpdate();
                this.dialogTimeOutVisible = true;
            },
            /**
             * #1794 — the 2x Dip border marks a SECOND EVENT that day, not a second call.
             *
             * ed: "the 2x Dip border should only apply when you are considered for a
             * second event on that same day." Two calls on ONE job across a day are one
             * event — a load-in and a later call — and must NOT get the border. A
             * different job the same day is a second event and does.
             *
             * Same-day stays NECESSARY; different-job is an ADDITIONAL condition, not a
             * replacement. `adjJobId` is the adjacent call's job, newly carried through
             * the payload as prev_Call_job_id / next_Call_job_id — before this it did
             * not exist anywhere on the wire, which is why the border could not tell
             * one event from two.
             *
             * ABSENT job id -> NO border. A missing id means we cannot prove a second
             * EVENT, and a false positive is exactly what ed reported; staying silent is
             * the safe direction. It also means an older payload degrades to no border
             * rather than to a wrong one.
             */
            checkPrevNextCallSameDay(dateTime, adjJobId) {
                let prevDate = moment(dateTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                let callStartDate = '';
                let callEndDate = '';
                if(this.$route.name == 'bulkAssignCustom') {
                    callStartDate = moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                    callEndDate = moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                }else {
                    callStartDate = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                    callEndDate = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                }
                if(prevDate==callStartDate||prevDate==callEndDate) {
                    // SECOND EVENT ONLY. Same job across the day is one event.
                    var viewedJobId = this.viewedJobId();
                    if (!adjJobId || !viewedJobId) {
                        return false;
                    }
                    return String(adjJobId) !== String(viewedJobId);
                }
                return false;
            },
            /**
             * #1794 — the job currently being assigned. The route carries it
             * base64-encoded, which is the same source isCurrentJobHTS already uses,
             * so the two cannot disagree about which job "this job" is.
             */
            viewedJobId() {
                try {
                    return atob(this.$route.params.id);
                } catch (e) {
                    return null;
                }
            },
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) {
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
            },
            getRoundOffSkillSeniority(seniorityVal) {
                if(seniorityVal && seniorityVal != '') {
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            async openDeclinedModal(emp) {
                if((this.userRoleSlug != 'employee') || (this.userRoleSlug == 'employee' && (this.isDispatcher || this.isSteward))) {
                    await this.$confirm('Do you want to Un-Decline', 'Un-Decline?', {
                    confirmButtonText: 'Undecline',
                    cancelButtonText: 'Cancel',
                    }).then(async () => {
                        await this.undeclinedCall(emp);
                    }).catch(() => {});
                }
            },

            async undeclinedCall(emp) {
                await service.post('call/undecline', {
                    'employee_id': emp.id,
                    'call_id': this.getDeclinedCallId(emp.call_actions),
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    let action = 'Decline'
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Success',
                        message: 'Call undeclined successfully.',
                        type: 'success'
                    });
                    bus.$emit('callUnDecline', action );
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: 'Warning',
                        message: 'Call undeclined Failed.',
                        type: 'warning'
                    });
                    this.$Progress.finish();
                });
            },

            getDeclinedCallId(data) {
                let call_id = data[0].call_id;
                if(data.length > 1) {
                    for(let i=0; i<data.length; i++) {
                        if(data[i].action_name == "Declined") {
                            call_id = data[i].call_id
                        }
                    }
                }
                return call_id;
            },

            /**
             * #1870 — "is the THIRD gap pill showing?"
             *
             * The Last-call / Next-call pair sits in a `<ul>` that renders a third
             * `<li>` between them — the job title of an HTS hold on ANOTHER job.
             * TWO things must agree on whether that pill is there:
             *
             *   the pill's own v-if
             *   the `o-half-div-width` override on the pills either side of it
             *
             * ⚠ THE CLASS NAME LIES. `.o-half-div` is `width: 50%` (style.css) and
             * `.o-half-div-width` is `width: auto` (this component) — it REMOVES the
             * width rather than giving half of one. Three pills at 50% would be 150%
             * and must wrap, so the auto width is what lets them share a row. It is
             * load-bearing for that case and is NOT removed.
             *
             * The bug was that the two predicates had DRIFTED: the override tested
             * `!isCurrentJobHTS(hts)` while the pill tested
             * `hts && hts.length && !isCurrentJobHTS(hts)`. `isCurrentJobHTS([])`
             * returns false — its forEach never runs — so for every employee with NO
             * hts at all the override fired while only TWO pills rendered, and they
             * wrapped into two rows for no reason. That is most of the grid.
             *
             * One predicate now, so they cannot drift again. The expression is the
             * pill's original one, verbatim: this is an extraction, not a rewrite,
             * and `employee.hts.length` is kept rather than `Object.keys(...)`
             * precisely so WHEN the third pill renders does not change.
             */
            htsElsewhere(employee){
                return !!(employee && employee.hts && employee.hts.length
                    && !this.isCurrentJobHTS(employee.hts));
            },
            isCurrentJobHTS(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                let flag=false;
                hts_list.forEach(hts => {
                    if(hts.job_id == atob(this.$route.params.id)){
                        flag=true;
                    }
                });
                return flag;
            },
          
            isCurrentHTSJob(hts_job_id) {
                if (hts_job_id == atob(this.$route.params.id)) {
                    return true;
                }
                return false;
            },

            getJobTitle(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                return (hts_list && hts_list.length? hts_list[0].job_name :'');
            },
            // #1690 T3 — HTS hover: name the job the soft-hold (possible conflict) is on.
            // The Last/Next-call gap pills go ORANGE when the worker is HTS-held on ANOTHER
            // job but show only a time — so on hover, name that job (Ed: "orange shows the
            // job name of the possible conflict"). Empty when not an elsewhere HTS hold, so
            // no stray tooltip on green/blue pills.
            htsHoverTitle(employee){
                if (employee && employee.hts && Object.keys(employee.hts).length > 0 && !this.isCurrentJobHTS(employee.hts)) {
                    const name = this.getJobTitle(employee.hts);
                    return name ? ('HTS hold on ' + name) : 'HTS hold on another job';
                }
                return '';
            },
            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [], noShows = [], sentHomes = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            case 'Declined':
                                declines.push(call);
                            break;
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            case 'Passed':
                                passes.push(call);
                            break;
                            // #1690 T5b — no-show / sent-home ride the decline tab but
                            // render YELLOW on the grid (Status.name: "No-show" / "Sent Home").
                            case 'No-show':
                                noShows.push(call);
                            break;
                            case 'Sent Home':
                                sentHomes.push(call);
                            break;

                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    case 'Declined':
                        return declines;
                    case 'Call Out':
                        return callouts;
                    case 'Timed Out':
                        return timeouts;
                    case 'Passed':
                        return passes;
                    case 'No-show':
                        return noShows;
                    case 'Sent Home':
                        return sentHomes;
                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },
            // #1690 T5b — a no-show / sent-home logged for this worker. Renders YELLOW
            // ("No-show" / "Sent Home", re-offerable "no" family) and blocks the assign
            // tool. The recorded status IS the record (logged on the decline tab).
            getNoShowSentHomeStatus(call_actions){
                return this.getCallActionByType(call_actions, "No-show").length > 0
                    || this.getCallActionByType(call_actions, "Sent Home").length > 0;
            },
            /**
             * #1794 — ANY response status, as ONE predicate.
             *
             * The available-row branch used to spell out four of the five by hand
             * and forgot no-show, so a no-show rendered as an available gap-pill
             * row with an assign box. The five branches below are the definition
             * of "has responded"; this is that same set, in one place, so the two
             * cannot drift apart again.
             *
             * DELIBERATELY NOT a change to any predicate's meaning — each term is
             * the existing function, unmodified. The only behaviour that changes
             * is that a no-show or sent-home stops matching the available branch.
             */
            hasResponseStatus(employee){
                const ca = employee.call_actions;
                return this.getDeclineStatus(ca)
                    || this.getNoShowSentHomeStatus(ca)
                    || this.getCallOutStatus(ca)
                    || this.getTimeOutStatus(ca)
                    || this.getPassStatus(ca);
            },
            /**
             * #1794 — which of the two this row actually is, for the pill colour.
             *
             * The branch handles no-show AND sent-home but the pill key was
             * hard-coded 'no_show', so a Sent Home rendered its own TEXT in
             * no-show's colour — cs3demo has them visibly different (#ff9edb vs
             * #ff00a2), which is exactly what ed is proofing.
             *
             * SAME TESTS IN THE SAME ORDER as getNoShowSentHomeLabel below, so
             * the colour and the words can never disagree about which one this
             * is. No-show wins over Sent Home because the label says so.
             */
            getNoShowSentHomeKey(call_actions){
                if (this.getCallActionByType(call_actions, "No-show").length) return 'no_show';
                if (this.getCallActionByType(call_actions, "Sent Home").length) return 'sent_home';
                return 'no_show';   // unreachable: the branch already gated on one of the two
            },
            getNoShowSentHomeLabel(call_actions){
                const ns = this.getCallActionByType(call_actions, "No-show");
                if (ns.length) return 'No-show : ' + ns[0].job_name;
                const sh = this.getCallActionByType(call_actions, "Sent Home");
                if (sh.length) return 'Sent Home : ' + sh[0].job_name;
                return '';
            },
            checkThisClickCooking(bookings,conflicts){
               if(conflicts) {}
               if(bookings.length>0 && bookings[0].client_id == this.userClientID){
                    return true;
                }
                return false;
            },

            checkAssignedJob(employee) {
                let bookings = employee.bookings;
                if(bookings.length>0 && bookings[0].client_id == this.userClientID &&  bookings[0].job_id == atob(this.$route.params.id)){
                    return true;
                }
                return false;
            },

            getParticipation(data){
                var result = 0;
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getParticipationJulyJune(data){
                var result = 0;
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getDeclineStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Declined");
                if((data.length>0 || Object.keys(data).length>0)){
                    return true;
                }
                return false;
            },

            getTimeStampValue(data){
                if(data)  return dateTimeConvert.utcTimeToUserTime(data);
                return '- - -';
            },

            getTimeStamp(data){
                if(data)  return moment(data).format('MM/DD/YYYYY @HH:mm:ss');
                return '- - -';
            },

            getGloabalDateTimeFormat(data) {
                if (!data || data === "0000-00-00 00:00:00" || isNaN(new Date(data).getTime())) {
                    return ""; 
                }
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },

            getGloabalDateFormat(data) {
                if (!data || data === "0000-00-00 00:00:00" || isNaN(new Date(data).getTime())) {
                    return "";
                }
                return dateTimeConvert.globalDate2(data,this.userDateFormat);
            },

            getPassStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Passed");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getTimeOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Timed Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCallOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Call Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCustomField(data) {
                var customFld = JSON.parse(data);
                let re = -1;
                let re2 = -1;
                if(customFld && customFld.value)
                {
                    re = customFld.value.search('{\"name\":');
                    let inner = "";
                    if(re>=0) {
                        inner = JSON.parse(customFld.value);
                        if(inner&&inner != ''&&inner.value)
                            re2 = customFld.value.search('{\"name\":')
                        if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                            return '';
                        return inner.value;
                    }else
                    return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';
                }
                return "";
            },

            employeeSummary() {
                this.$modal.show('employeeSummary');
            },

            hideModal() {
                this.$modal.hide();
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },

            getConflictDate(dateTime) {
                return dateTimeConvert.localDate(dateTime, 'DD MMM');
            },

            checkTurnOver(calls){
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length>=2 && Number(duration[0]) <= 24){
                        let hours =  Number(duration[0]);
                        if(hours < this.turnoverTime){
                            return true;
                        }
                    }
                }
                return false;
            },

            getPrevCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Last call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Last call 24:00+";
            },
            getPrevCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextVacationAndCallTime(vacation,calls) {
                let result1 = '';
                let result2 = '';
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result1 =  'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                if(vacation && Object.keys(vacation).length){
                    let duration = vacation[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result2 = 'Next vacation: '+moment(vacation[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return result1 + ', ' + result2;
            },

            getNextVacationTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next vacation '+moment(calls[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },
            getNextCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },

            // removed the unused code for unavailability on 02-02-2023 20:30:00
            recurringUnavailability(unavailability_list) {
                var flag=false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            var temp = unavailabilityList1[j];
                            var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';

                            let isOvernightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                            if(isOvernightUnavailability) {
                                end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                let day1UnavailabilityStart = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay1UnavailabilityEnd = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '23:59:59';
                                let day1UnavailabilityEnd = moment(tempDay1UnavailabilityEnd, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay2UnavailabilityStart = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '00:00:00';
                                let day2UnavailabilityStart = moment(tempDay2UnavailabilityStart, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let day2UnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");

                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[i],temp);
                                if(flag) return flag;

                                let dayIndex = i;
                                if(i==6) dayIndex=-1;

                                // #1680 — an overnight RU window's DAY-1 portion belongs to its
                                // OWN weekday (already checked above under weekDaysNames[i]); only
                                // the genuine DAY-2 spillover (00:00 → wrap) carries the next-day
                                // label. The removed check re-tested the day-1 range under the
                                // next-day label, so e.g. a Friday ["04:55","01:00"] block made a
                                // Saturday daytime call unselectable (green tile, no checkbox).
                                // Now matches backend RecurringUnavailabilityCheck.
                                flag = this.checkCallDateUnavailability(day2UnavailabilityStart, day2UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;
                            }else {
                                if((moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                                    let day1CallStart = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let tempDay1CallEnd =  moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    let tempDay2CallStart =  moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let day2CallEnd = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]){
                                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                                        if(flag) return flag;
                                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                                        if(flag) return flag;
                                    }
                                }else {
                                    if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        if(flag) return flag;
                                    }
                                }
                            }
                        }
                    }
                }
                return flag;
            },

            checkCallDateUnavailability(start, end, callStartTime, callEndTime, day,temp) {
                let flag = false;
                if((moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                    let day1CallStart = moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let tempDay1CallEnd =  moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    let tempDay2CallStart =  moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let day2CallEnd = moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day){
                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                        if(flag) return flag;
                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                        if(flag) return flag;
                    }
                }else {
                    if(moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        flag = dateTimeConvert.dateCheck(start,end, callStartTime, callEndTime);
                        if(flag) return flag;
                    }
                }
                return flag;
            },

            recurringUnavailability1(unavailability_list){  //removed... not calling any where, just for reference
                let flag=false;
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    let dayNum1=moment(this.callStartTime).format('d');

                    dayNum1=Number(dayNum1)+1;
                    let unavailabilityList1=unavailabilityList[dayNum1];
                    for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                        var temp = unavailabilityList1[i];
                        var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                        if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                    let dayNum2=moment(this.callEndTime).format('d');
                    dayNum2=Number(dayNum2)+1;
                    if(this.callStartTime.split(' ')[0] != this.callEndTime.split(' ')[0]) {
                        let unavailabilityList2=unavailabilityList[dayNum2];
                        for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                            var temp = unavailabilityList2[i];
                            var start = this.callEndTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callEndTime.split(' ')[0]+' '+temp[1]+':00';
                            if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                                flag=true;
                                return flag;
                            }
                        }
                    }
                }
                return flag;
            },
            checkVacationWithinCall(vacations) {

                if(vacations.length>0){
                    return true;
                }else{
                    return false;
                }
            },
        },
        created() {
            this.fetchStatusColors();
            switch(this.columnLabel){
                case "skill_seniority":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "shift_count_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shift_count_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shifts_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_cell_phone":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_name":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "conflicts":
                    this.columnClass='calls-table-cell tcell_7'
                    break;
                case "shifts_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "location":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "decline_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation_july_june_desc":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "member_since":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "date_of_hire":
                    this.columnClass='calls-table-cell tcell_4'
                    break;

                case "last_offer":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_assigned":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_confirmed":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "wishlist":
                    this.columnClass='calls-table-cell tcell_3'
                    break;
                case "employee_seniority":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field1":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field2":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
            }
            this.turnoverTime = this.client.turnover;
            // this.selectedSortType = this.client.default_sort;
            this.customField1 = this.client.custom_field_1;
            this.customField2 = this.client.custom_field_2;
            this.showCustom = this.client.call_assignment_title;
            this.callAssigmentSettings = this.client.settings['call-assignment-config'];
        }

    }

</script>
<style scoped>
.o-common-modal-content {
    padding-bottom: 15px !important;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
.u-btn-blue {
    background: #37bae8!important;
}

.u-btn-yellow1 {
    background: #e8e000bf!important;
}
.u-btn-text-red1 {
    color: red!important;
}
.u-btn-border-red {
    border: solid 5px red;
}
.o-half-div-width{
    width: auto;
}
</style>

<style>
.el-dialog.pass-time-out-modal {
    border: 2px solid #000000;
    border-radius: 5px;
}
.pass-time-out-modal .el-dialog__header {
    padding: 0;
    margin-top: 0px;
    /* display: none; */
    /* border-bottom: 2px solid #000000; */
}
.pass-time-out-modal .el-dialog__body {
    padding: 0;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 {
    padding: 20px 20px 0;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .employee-summary-profile{
    text-align: left;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .employee-summary-profile--inline{
    margin: 0;
}
.pass-time-out-modal .el-dialog__body .o-ndividualTable {
    padding: 0 20px 10px!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .c-common-space {
    margin-bottom: 0!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-inline-datepicker-icon {
    width: 160px!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-schedule-month a {
    /* font-size: 18px; */
    /* color: #4D7FAE; */
    margin-left: 2px;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-filter-area {
    margin-right: 32px;
}
.pass-time-out-modal .el-dialog__body .o-ndividualTable .o-schedule-table {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn {
    top: 0;
    right: 0;
    padding: 10px;
    background-color: #fc3b3b;
    color: #ffffff;
    z-index: 999;
}

.pass-time-out-modal .el-dialog__header .el-dialog__title {
    display: none;
    /* font-size: 24px; */
    /* color: #000000; */
    /* font-weight: bold; */
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn .el-icon-close {
    color: #ffffff;
    font-weight: bold;
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn .el-icon-close:hover {
    color: #ffffff!important;
    font-weight: bold;
}
/* .pass-time-out-modal {
    border: 2px solid #000000;
    border-radius: 5px;
} */
</style>
